import { useCollectionPager } from 'framework/ViewTypes/hooks';
import { FilterCondition } from 'framework/types';
import type { CollectionViewParamsConfig } from 'framework/ViewTypes/hooks';
import { BUISNESS_FUNCTION_PAGE_SIZE } from '../constants';
import type { BuisnessFunctionFilters, BuisnessFunctionListItem } from '../types';
import useBuisnessFunctionService from '../useBuisnessFunctionService';

const VIEW_PARAMS_CONFIG: CollectionViewParamsConfig<BuisnessFunctionFilters> = {
  cache: true,
  filterRules: {
    state: { condition: FilterCondition.IN },
    administrator: { condition: FilterCondition.EQ },
  },
  sortableColumns: ['name', 'administrator', 'state'],
};

const useBuisnessFunctionCollection = () => {
  const { search } = useBuisnessFunctionService();

  return useCollectionPager<BuisnessFunctionListItem, BuisnessFunctionFilters>({
    pageSize: BUISNESS_FUNCTION_PAGE_SIZE,
    viewParamsConfig: VIEW_PARAMS_CONFIG,
    fetchPage: ({ pageNumber, pageSize, filters, searchValue, sort, signal }) =>
      search({
        pageNumber,
        pageSize,
        filters,
        searchValue,
        sort,
        signal,
      }),
  });
};

export default useBuisnessFunctionCollection;
